import PageWrapper from 'components/utils/PageWrapper';
import PortfolioCreationWizardPrototype from 'pages/PortfolioCreationWizardPrototype';

export const portfolioCreationWizardRoutes = {
    path: '/portfolio-creation-wizard',
    element: (
        <PageWrapper titleId="item_creation_wizard" title={"PROTOTYPE"} >
            <PortfolioCreationWizardPrototype />
        </PageWrapper>
    ),
};
